import platform from '@propertypal/shared/src/utils/platform';
import ProductsHeader from '@propertypal/web-ui/src/headers/products/ProductsHeader';
import ProductsContact from '@propertypal/web-ui/src/products/ProductsContact';
import WhyPropertyPalContent from '@propertypal/web-ui/src/products/WhyPropertyPalContent';
import Head from 'next/head';
import React from 'react';
import generateMetaTags from '../../components/layout/MetaTags';

const metaData = {
  title: `Products & Services - ${platform.title}`,
  description:
    'View Our Range Of Agent And Developer Products And Solutions To Help Enhance Your Brand And Get Your Listings Seen By More People.',
  url: `/products`,
};

const WhyPropertyPal = () => {
  return (
    <>
      <Head>{generateMetaTags(metaData)}</Head>

      <ProductsHeader />
      <WhyPropertyPalContent />
      <ProductsContact reason="Products & Services" />
    </>
  );
};

export default WhyPropertyPal;
